module.exports = __webpack_public_path__ + "media/images/emblems/Bolken-blason-484a68f191ab9177aa971524374987a8.png";